import { RefObject, useCallback } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

import { useClickOutsideContext } from '~/providers/ClickOutsideProvider'

const useClickOutside = (
  ref: RefObject<any>,
  callback: () => void,
  deps: any[] = [],
) => {
  const { canClickOutside } = useClickOutsideContext()

  const handleClick = useCallback(
    (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (canClickOutside && ref.current && !ref.current.contains(target) && document.body.contains(target)) {
        callback()
      }
    },
    [canClickOutside, ...deps],
  )

  useIsomorphicLayoutEffect(() => {
    document.addEventListener('click', handleClick)
    document.addEventListener('touchstart', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('touchstart', handleClick)
    }
  })
}

export default useClickOutside
